import React, { useState } from 'react';

const PopoverMenuItem = ({ text, action, onClose }) => {
  const [hover, setHover] = useState(false);
  const blue = '#006CFF';

  const handleMouseEnter = () => setHover(true);
  const handleMouseLeave = () => setHover(false);

  const handleClick = () => {
    action();
    onClose();
  };

  return (
    <div
      onClick={handleClick}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      style={{
        ...styles.container,
        backgroundColor: hover ? blue : 'white',
        color: hover ? 'white' : 'black',
      }}
    >
      {text}
    </div>
  );
};

const styles = {
  container: {
    padding: 16,
    transition: 'all 300ms ease',
    cursor: 'pointer',
  },
};

export default PopoverMenuItem;
